<template>
    <v-list-item
        v-on="on"
        class="menu-list-item"
        :class="item.highlight ? 'primary lighten-2' : ''"
        style="height: 32px !important; min-height: 32px !important;"
        @click="onActionClick()"
    >
        <v-list-item-icon
            v-if="item.icon" class="d-flex align-center"
            :class="item.smallIconMargin ? 'mr-2' : ''"
        >
            <icon :color="item.iconColor" :icon="item.icon" :size="item.iconSize"/>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                {{ item.text }}
            </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon v-if="hasSubMenu">
            <v-icon color="g4">mdi-menu-right</v-icon>
        </v-list-item-icon>
    </v-list-item>
</template>

<script>

export default {
    name: "ActionMenuItem",
    props: {
        item: {
            type: Object,
            required: true
        },
        hasSubMenu: {
            type: Boolean,
            default: false
        },
        on: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, ctx) {
        const onActionClick = () => {
            ctx.emit("action")
        }

        return {
            onActionClick
        }
    }
}

</script>

<style scoped lang="scss">

</style>